import { useState } from "react";
import { Fragment } from "react";
import { toast } from "react-toastify";
import { validationTypes } from "../../assets/constants/constant";

const FormInput = ({
  name,
  label,
  register,
  rule,
  placeholder,
  id,
  className,
  error,
  errorMessage,
  type,
  labelClass,
  svg,
  paswordElement,
  img,
  disabled,
  textArea,
  rows,
  height,
  length,
  accept,
  multiple,
  min,
}) => {
  const validation = (type, charLength) => {
    let error = "";
    if (type.type === validationTypes?.minLength) {
      error = "Field must be at least 3 characters long.";
    }
    if (type.type === validationTypes?.maxLength) {
      error = `The max length of ${charLength} characters is reached.`;
    }
    if (type.type === validationTypes?.required) {
      error = "This field is required";
    }
    if (type.type === validationTypes?.pattern) {
      error = "This field accepts a number.";
    }
    if (type.type === validationTypes?.manual) {
      error = type?.message;
    }
    return error;
  };

  return (
    <Fragment>
      {label && (
        <label className={`form-label ${labelClass}`}>
          <h6 className="mb-0">{label}</h6>
        </label>
      )}

      <div className="position-relative">
        {textArea ? (
          <textarea
            id={id}
            className={`${className ? className : "form-control-textarea"} ${
              error ? "errorBorder" : ""
            }`}
            placeholder={placeholder || ""}
            name={name}
            rows={rows}
            {...register(name, { ...rule })}
            style={{ height: height }}
          />
        ) : (
          <input
            id={id}
            className={`${className ? className : "form-control"} ${
              error ? "errorBorder" : ""
            }`}
            type={type || "text"}
            placeholder={placeholder || ""}
            name={name}
            maxLength={type === "text" && name === "price" && 8}
            multiple={(type = "file" ? multiple : null)}
            accept={(type = "file" ? accept : null)}
            min={min || 0}
            {...register(name, {
              ...rule,
            })}
            disabled={disabled}
          />
        )}
        {(name === "password" || name === "confirmPassword") && paswordElement}
        {svg ? svg : null}
        {img ? img : null}
      </div>
      {error && <small className="errorMsg">{validation(error, length)}</small>}
    </Fragment>
  );
};

export default FormInput;
